import { get } from "lodash";
import * as constants from "../../constants";

const inititalState = {
  isLoading: false,
  apparanceThemes: {
    data: null,
    error: null,
  },
  updateAppearanceThemes: {
    data: null,
    error: null,
  },
  resetAppearanceThemes: {
    data: null,
    error: null,
  },
}

export default function (state = inititalState, action) {
  switch (action.type) {
    case constants.APPEARANCE_THEMES_REQUEST:
      return {
        ...state,
        isLoading: action.payload,
        appearanceThemes: {
          error: null,
          data: null,
        },
      }
    case constants.APPEARANCE_THEMES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        appearanceThemes: {
          error: null,
          data: action.payload,
        },
      }
    case constants.APPEARANCE_THEMES_ERROR:
      return {
        ...state,
        isLoading: false,
        appearanceThemes: {
          error: action.payload,
          data: null,
        },
      }

    case constants.UPDATE_APPEARANCE_THEMES_REQUEST:
      return {
        ...state,
        isLoading: action.payload,
        updateAppearanceThemes: {
          error: null,
          data: null,
        },
      }
    case constants.UPDATE_APPEARANCE_THEMES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        updateAppearanceThemes: {
          error: null,
          data: action.payload,
        },
      }
    case constants.UPDATE_APPEARANCE_THEMES_ERROR:
      return {
        ...state,
        isLoading: false,
        updateAppearanceThemes: {
          error: action.payload,
          data: null,
        },
      }

      case constants.RESET_APPEARANCE_THEMES_REQUEST:
      return {
        ...state,
        isLoading: action.payload,
        resetAppearanceThemes: {
          error: null,
          data: null,
        },
      }
    case constants.RESET_APPEARANCE_THEMES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        resetAppearanceThemes: {
          error: null,
          data: action.payload,
        },
      }
    case constants.RESET_APPEARANCE_THEMES_ERROR:
      return {
        ...state,
        isLoading: false,
        resetAppearanceThemes: {
          error: action.payload,
          data: null,
        },
      }
    default:
      return state;
  }
}

export const getIsLoading = (state) => get(state, 'appearance.isLoading');
export const getAppearanceThemesData = (state) => get(state, 'appearance.appearanceThemes.data');
export const getUpdatedAppearanceThemesData = (state) => get(state, 'appearance.updateAppearanceThemes.data');
export const getResetAppearanceThemesData = (state) => get(state, 'appearance.resetAppearanceThemes.data');
export const getUpdateAppearanceThemesErrors = (state) => get(state, 'appearance.updateAppearanceThemes.error[0].response.data.validationErrors');